var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentTag,_vm._g(_vm._b({tag:"component",staticClass:"button",class:_vm.modifiers},'component',_vm.attributes,false),_vm.$listeners),[_vm._t("default",[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }